var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "documents-report-filters" },
    [
      _vm.open
        ? _c("c-button-2", {
            staticClass: "documents-report-filters__toggler",
            attrs: { label: "Скрыть фильтры" },
            on: {
              click: function ($event) {
                _vm.open = false
              },
            },
          })
        : _vm._e(),
      _c("transition", { attrs: { name: "slide" } }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.open,
                expression: "open",
              },
            ],
            staticClass: "documents-report-filters__slide",
          },
          [
            _vm.inited
              ? _c(
                  "div",
                  { staticClass: "documents-report-filters__wrapper" },
                  [
                    _c("c-input-2", {
                      staticClass:
                        "documents-report-filters__item documents-report-filters__filial",
                      attrs: {
                        type: "select",
                        label: "Филиал",
                        "checkbox-value": _vm.form.filialsExcept,
                        checkbox: true,
                        "checkbox-type": "icon",
                        "checkbox-tooltip": _vm.exceptTooltip,
                        multiple: true,
                        searchable: true,
                        placeholder: "Все",
                        items: _vm.collections.filials,
                      },
                      on: {
                        checkboxChange: function ($event) {
                          _vm.form.filialsExcept = $event
                        },
                      },
                      model: {
                        value: _vm.form.filials,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "filials", $$v)
                        },
                        expression: "form.filials",
                      },
                    }),
                    _c("c-input-2", {
                      staticClass:
                        "documents-report-filters__item documents-report-filters__position",
                      attrs: {
                        type: "select",
                        label: "Должность",
                        "checkbox-value": _vm.form.positionsExcept,
                        checkbox: true,
                        "checkbox-type": "icon",
                        "checkbox-tooltip": _vm.exceptTooltip,
                        multiple: true,
                        searchable: true,
                        placeholder: "Все",
                        items: _vm.collections.positions,
                      },
                      on: {
                        checkboxChange: function ($event) {
                          _vm.form.positionsExcept = $event
                        },
                      },
                      model: {
                        value: _vm.form.positions,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "positions", $$v)
                        },
                        expression: "form.positions",
                      },
                    }),
                    _c("c-input-2", {
                      staticClass:
                        "documents-report-filters__item documents-report-filters__query",
                      attrs: {
                        label: "Имя или телефон",
                        clearable: true,
                        placeholder: "Любые",
                      },
                      on: {
                        enter: function ($event) {
                          return _vm.$emit("apply")
                        },
                      },
                      model: {
                        value: _vm.form.nameOrPhone,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "nameOrPhone", $$v)
                        },
                        expression: "form.nameOrPhone",
                      },
                    }),
                    _c("c-input-2", {
                      staticClass:
                        "documents-report-filters__item documents-report-filters__citizenship",
                      attrs: {
                        type: "select",
                        label: "Гражданство",
                        "checkbox-value": _vm.form.citizenshipsExcept,
                        checkbox: true,
                        "checkbox-type": "icon",
                        "checkbox-tooltip": _vm.exceptTooltip,
                        multiple: true,
                        searchable: true,
                        placeholder: "Все",
                        items: _vm.collections.citizenships,
                      },
                      on: {
                        checkboxChange: function ($event) {
                          _vm.form.citizenshipsExcept = $event
                        },
                      },
                      model: {
                        value: _vm.form.citizenships,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "citizenships", $$v)
                        },
                        expression: "form.citizenships",
                      },
                    }),
                    _c("c-input-2", {
                      staticClass:
                        "documents-report-filters__item documents-report-filters__law-status",
                      attrs: {
                        type: "select",
                        label: "Правовой статус",
                        "checkbox-value": _vm.form.lawStatusesExcept,
                        checkbox: true,
                        "checkbox-type": "icon",
                        "checkbox-tooltip": _vm.exceptTooltip,
                        multiple: true,
                        searchable: true,
                        placeholder: "Все",
                        items: _vm.collections.lawStatuses,
                      },
                      on: {
                        checkboxChange: function ($event) {
                          _vm.form.lawStatusesExcept = $event
                        },
                      },
                      model: {
                        value: _vm.form.lawStatuses,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "lawStatuses", $$v)
                        },
                        expression: "form.lawStatuses",
                      },
                    }),
                    _c("c-input-2", {
                      staticClass:
                        "documents-report-filters__item documents-report-filters__work-status",
                      attrs: {
                        type: "select",
                        label: "Статус",
                        "checkbox-value": _vm.form.workStatusesExcept,
                        checkbox: true,
                        "checkbox-type": "icon",
                        "checkbox-tooltip": _vm.exceptTooltip,
                        multiple: true,
                        searchable: true,
                        placeholder: "Все",
                        items: _vm.collections.workStatuses,
                      },
                      on: {
                        checkboxChange: function ($event) {
                          _vm.form.workStatusesExcept = $event
                        },
                      },
                      model: {
                        value: _vm.form.workStatuses,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "workStatuses", $$v)
                        },
                        expression: "form.workStatuses",
                      },
                    }),
                    _c("c-input-2", {
                      staticClass:
                        "documents-report-filters__item documents-report-filters__doc-type",
                      attrs: {
                        type: "select",
                        label: "Тип документа",
                        multiple: true,
                        searchable: true,
                        placeholder: "Все",
                        items: _vm.collections.docTypes,
                      },
                      model: {
                        value: _vm.form.docTypes,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "docTypes", $$v)
                        },
                        expression: "form.docTypes",
                      },
                    }),
                    _c("c-select", {
                      staticClass:
                        "documents-report-filters__item documents-report-filters__document",
                      attrs: {
                        type: "select",
                        label: "Наименование документа",
                        multiple: true,
                        searchable: true,
                        placeholder: "Все",
                        items: _vm.collections.documents,
                        groups: _vm.collections.docTypes,
                      },
                      model: {
                        value: _vm.form.documents,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "documents", $$v)
                        },
                        expression: "form.documents",
                      },
                    }),
                    _c("c-input-2", {
                      staticClass:
                        "documents-report-filters__item documents-report-filters__criticality",
                      attrs: {
                        type: "select",
                        label: "Критичность документа",
                        multiple: true,
                        searchable: true,
                        placeholder: "Все",
                        items: _vm.collections.criticality,
                      },
                      model: {
                        value: _vm.form.criticality,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "criticality", $$v)
                        },
                        expression: "form.criticality",
                      },
                    }),
                    _c("c-input-2", {
                      staticClass:
                        "documents-report-filters__item documents-report-filters__deadline",
                      attrs: {
                        type: "select",
                        label: "Срок годности документа",
                        multiple: true,
                        searchable: true,
                        placeholder: "Все",
                        items: _vm.collections.deadlines,
                      },
                      model: {
                        value: _vm.form.deadlines,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "deadlines", $$v)
                        },
                        expression: "form.deadlines",
                      },
                    }),
                    _c("c-range", {
                      staticClass:
                        "documents-report-filters__item range documents-report-filters__deadline-range",
                      attrs: {
                        max: 60,
                        min: 0,
                        label: "Истекает срок годности в течение, дн.",
                      },
                      model: {
                        value: _vm.form.deadlineRange,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "deadlineRange", $$v)
                        },
                        expression: "form.deadlineRange",
                      },
                    }),
                    _c("c-switcher", {
                      staticClass:
                        "documents-report-filters__item switcher documents-report-filters__problems",
                      attrs: { label: "Проблемы с документами" },
                      model: {
                        value: _vm.form.withProblems,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "withProblems", $$v)
                        },
                        expression: "form.withProblems",
                      },
                    }),
                    _c(
                      "div",
                      {
                        staticClass:
                          "documents-report-filters__item documents-report-filters__actions",
                      },
                      [
                        _c("c-button", {
                          staticClass: "documents-report-filters__reset",
                          attrs: { size: "large", label: "Сбросить" },
                          on: { click: _vm.reset },
                        }),
                        _c("c-button", {
                          staticClass: "documents-report-filters__apply",
                          attrs: {
                            label: "Применить",
                            color: "blue",
                            size: "large",
                          },
                          on: { click: _vm.apply },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
          ]
        ),
      ]),
      _vm.open
        ? _c("c-button-2", {
            staticClass: "documents-report-filters__toggler",
            attrs: { label: "Скрыть фильтры" },
            on: {
              click: function ($event) {
                _vm.open = false
              },
            },
          })
        : _vm._e(),
      !_vm.open
        ? _c("c-button-2", {
            staticClass: "documents-report-filters__toggler",
            attrs: { label: "Показать фильтры" },
            on: {
              click: function ($event) {
                _vm.open = true
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }